/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useAuth, isGuestUser } from "../../../../context/AuthContext";
import { useModal } from "../../../../context/ModalContext";
import { buildSellerNetPayload } from "../../../../utils/payloadBuilder";
import { CommonHeader } from "../../../../components/ui/CommonHeader";
import GeneralInformationSection from "../../components/GeneralInformationSection";
import SalesPriceSection from "./SalesPriceSection";
import ClosingCostsSection from "./ClosingCostsSection";
import EditableClosingCostsSection from "./EditableClosingCostsSection";
import CompensationSection from "./CompensationSection";
// import OtherCostsSection from "./OtherCostsSection";
import TotalsSection from "./TotalsSection";
import DisclaimerModal from "../../popups/DisclaimerModal";
import EmailModal from "../../popups/EmailModal";
import TextMessageModal from "../../popups/TextMessageModal";
import AmortizationScheduleModal from "../../popups/AmortizationScheduleModal";

export default function ManualSheetSection(props) {
  const {
    mainId,
    FloatingInput,
    FloatingNumber,
    CustomSelect,
    handleCurrencyBlur,
    onSalesPriceBlur,
    control,
    watch,
    setValue,
    getValues,
    sellerClosingCostArray,
    closingCostsSection2Array,
    compensationArray,
    cleanNumber,
    checkValidSalesPrice,
    handleDownloadPrintPDF,
    handleSellerCalculation,
    setUseMortgageBalance,
    ttbData,
    showToaster,
    onClose,
    handleSaveCalc,
    isQuickMode,
    onAddressEnriched,
    onZipVerified,
  } = props;
  // Hooks and Context
  const { user } = useAuth();
  const { openModal, closeModal } = useModal();

  // State
  const [salesPriceFormattedTick, setSalesPriceFormattedTick] = useState(0);

  // Helper Functions
  const getVal = (path, fallback = "") => {
    try {
      if (typeof getValues === "function") {
        const v = getValues(path);
        return v === undefined ? fallback : v;
      }
    } catch (e) {
      return fallback;
    }
    return fallback;
  };

  const getCurrentValue = (path) => (watch ? watch(path) : getVal(path));

  // Derived Values
  const totalClosingMeta = getCurrentValue("totalClosingMeta") || {};

  // Event Handlers
  const handleActionButton = (action) => {
    if (action === "disclaimer") {
      openModal({
        title: "Disclaimer",
        size: "mediumsizewidth",
        content: <DisclaimerModal calc="seller" onClose={closeModal} />,
      });
      return;
    }
    const isValid = checkValidSalesPrice();
    if (!isValid) {
      return;
    }

    if (
      action === "download" ||
      action === "downloadQuick" ||
      action === "print" ||
      action === "printQuick"
    ) {
      handleDownloadPrintPDF(action, "seller");
      return;
    }

    // emailQuick/textQuick reuse the same modals as email/text — the only
    // difference is isQuickEstimate, which tells the backend to render the
    // property-showcase template instead of the regular detailed one.
    const isQuickEstimate = action === "emailQuick" || action === "textQuick";
    const normalizedAction =
      action === "emailQuick" ? "email" : action === "textQuick" ? "text" : action;

    const formData = buildSellerNetPayload({
      getVal,
      user,
      calculatorname: "Seller Net Sheet",
    });

    const modals = {
      email: {
        title: isQuickEstimate
          ? "Email a Showcase"
          : "Email a Closing Cost Estimate",
        content: (
          <EmailModal
            onClose={closeModal}
            type="seller"
            showToaster={showToaster}
            sellerFormData={formData}
            isQuickMode={isQuickMode}
            isQuickEstimate={isQuickEstimate}
          />
        ),
      },
      text: {
        title: isQuickEstimate
          ? "Text a Showcase to Customer"
          : "Text Message to Customer",
        content: (
          <TextMessageModal
            onClose={closeModal}
            type="seller"
            showToaster={showToaster}
            sellerFormData={formData}
            isQuickMode={isQuickMode}
            isQuickEstimate={isQuickEstimate}
          />
        ),
      },
      AmortizationSch: {
        title: "Amortization Schedule",
        content: (
          <AmortizationScheduleModal
            onClose={closeModal}
            type="seller"
            showToaster={showToaster}
            sellerFormData={formData}
            handleEmail={handleAmortizationEmail}
            handlePrint={handleAmortizationPrint}
          />
        ),
      },
      disclaimer: {
        title: "Disclaimer",
        size: "mediumsizewidth",
        content: <DisclaimerModal calc="seller" onClose={closeModal} />,
      },
    };

    if (modals[normalizedAction]) {
      if (normalizedAction === "AmortizationSch") {
        openModal({ ...modals[normalizedAction], size: "halffull" });
      } else {
        openModal({ ...modals[normalizedAction], size: "mediumsizewidth" });
      }
    }
  };

  const handleAmortizationEmail = () => {
    const formData = buildSellerNetPayload({
      getVal,
      user,
      calculatorname: "Seller Net Sheet",
    });

    openModal({
      title: "Email Amortization Schedule",
      size: "mediumsizewidth",
      content: (
        <EmailModal
          onClose={closeModal}
          type="seller"
          calc="AmortizationSch"
          showToaster={showToaster}
          sellerFormData={formData}
        />
      ),
    });
  };

  const handleAmortizationPrint = () => {
    handleDownloadPrintPDF("print", "AmortizationSch");
  };

  // Render Helpers
  const renderHeaderButtons = () => (
    <div className="ch-btnsave">
      <button type="button" className="ch-btnsave-new" onClick={onClose}>
        New
      </button>
      {!isGuestUser(user) && (
        <button
          type="button"
          className="ch-btnsave-save"
          onClick={handleSaveCalc}
        >
          Save
        </button>
      )}
    </div>
  );

  return (
    <div className="model-body-calc-pg">
      <div className="calculator-page application-fe">
        <CommonHeader title="Seller's Net Sheet">
          {renderHeaderButtons()}
        </CommonHeader>

        <div className="row-three-wrap">
          {/* Column A */}
          <div className="calc-column-a">
            <GeneralInformationSection
              // FloatingInput={FloatingInput}
              control={control}
              getValues={getValues}
              setValue={setValue}
              user={user}
              openModal={openModal}
              closeModal={closeModal}
              showToaster={showToaster}
              onSalesPriceBlur={onSalesPriceBlur}
              onAddressEnriched={onAddressEnriched}
              onZipVerified={onZipVerified}
            />

            <SalesPriceSection
              FloatingInput={FloatingInput}
              FloatingNumber={FloatingNumber}
              CustomSelect={CustomSelect}
              control={control}
              getValues={getValues}
              setValue={setValue}
              watch={watch}
              cleanNumber={cleanNumber}
              handleCurrencyBlur={handleCurrencyBlur}
              onSalesPriceBlur={(formatted) => {
                setSalesPriceFormattedTick((t) => t + 1);
                onSalesPriceBlur?.(formatted);
              }}
              setUseMortgageBalance={setUseMortgageBalance}
              ttbData={ttbData}
              salesPriceFormattedTick={salesPriceFormattedTick}
              handleSellerCalculation={handleSellerCalculation}
            />
          </div>

          {/* Column B */}
          <div className="calc-column-b">
            <ClosingCostsSection
              mainId={mainId}
              control={control}
              FloatingInput={FloatingInput}
              FloatingNumber={FloatingNumber}
              CustomSelect={CustomSelect}
              getValues={getValues}
              setValue={setValue}
              openModal={openModal}
              closeModal={closeModal}
              cleanNumber={cleanNumber}
              sellerClosingCostArray={sellerClosingCostArray}
              closingCostsSection2Array={closingCostsSection2Array}
              totalClosingMeta={totalClosingMeta}
              salesPriceFormattedTick={salesPriceFormattedTick}
              handleSellerCalculation={handleSellerCalculation}
            />

            <EditableClosingCostsSection
              control={control}
              FloatingInput={FloatingInput}
              getValues={getValues}
              setValue={setValue}
              cleanNumber={cleanNumber}
              salesPriceFormattedTick={salesPriceFormattedTick}
              handleSellerCalculation={handleSellerCalculation}
              CustomSelect={CustomSelect}
              closingCostsSection2Array={closingCostsSection2Array}
              totalClosingMeta={totalClosingMeta}
            />
          </div>

          {/* Column C */}
          <div className="calc-column-c">
            <CompensationSection
              control={control}
              FloatingInput={FloatingInput}
              getValues={getValues}
              setValue={setValue}
              cleanNumber={cleanNumber}
              compensationArray={compensationArray}
              salesPriceFormattedTick={salesPriceFormattedTick}
              handleSellerCalculation={handleSellerCalculation}
              CustomSelect={CustomSelect}
              totalClosingMeta={totalClosingMeta}
            />
            {/*     <OtherCostsSection
              control={control}
              FloatingInput={FloatingInput}
              FloatingNumber={FloatingNumber}
              getValues={getValues}
              setValue={setValue}
              cleanNumber={cleanNumber}
              otherCostArray={otherCostArray}
              sellerOtherCostArray={sellerOtherCostArray}
              totalClosingMeta={totalClosingMeta}
              salesPriceFormattedTick={salesPriceFormattedTick}
              handleSellerCalculation={handleSellerCalculation}
            /> */}

            <TotalsSection
              control={control}
              FloatingNumber={FloatingNumber}
              getValues={getValues}
              cleanNumber={cleanNumber}
              totalClosingMeta={totalClosingMeta}
              handleActionButton={handleActionButton}
              onDisclaimerClick={() => handleActionButton("disclaimer")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
